// extracted by mini-css-extract-plugin
module.exports = {"heatApp":"Input_heatApp__8CbCF","olandschokladApp":"Input_olandschokladApp__wTbJ2"};